import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/content";
import { errorText } from "@/lib/errors";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

const COPY = {
  confirm: ["You're signed up", "We'll email you whenever we publish a new free guide."],
  unsubscribe: ["You're unsubscribed", "You won't get any more guide emails from us."],
};

export default function Newsletter() {
  const [params] = useSearchParams();
  const action = params.get("action") === "unsubscribe" ? "unsubscribe" : "confirm";
  const [state, setState] = useState("working");
  const [error, setError] = useState("");

  useEffect(() => {
    axios.post(`${API}/newsletter/${action}`, { token: params.get("token") || "" })
      .then(() => setState("done"))
      .catch((err) => { setError(errorText(err)); setState("error"); });
  }, [action, params]);

  const [title, body] = state === "done" ? COPY[action] : state === "error" ? ["Something's not right", error] : ["One moment", "..."];
  return (
    <div className="site bg-sage text-pine min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-6 py-24 md:py-32" data-testid="newsletter-page">
        <p className="lb text-brass-ink">Free guide updates</p>
        <h1 className="dp mt-6" data-testid="newsletter-title"><em>{title}.</em></h1>
        <p className="mt-6 text-moss" data-testid="newsletter-message">{body}</p>
        <div className="mt-10 flex flex-wrap gap-6 items-center">
          <Link to="/resources" className="bg-pine text-sage rounded-full px-7 py-4" data-testid="newsletter-guides-button">Browse free guides</Link>
          <Link to="/" className="underline underline-offset-4 decoration-brass" data-testid="newsletter-home-link">Back to home</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
